import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { firebaseApp } from '../firebase';

/**
 * Serviço para gerenciar as notificações push
 * Inclui funções para solicitar permissão, gerenciar tokens e receber notificações
 */
class NotificationService {
  constructor() {
    this.messaging = null;
    this.initialized = false;
    this.onMessageCallback = null;
  }

  /**
   * Inicializa o serviço de mensagens
   * @returns {Promise<boolean>} Indica se a inicialização foi bem-sucedida
   */
  async init() {
    if (this.initialized) return true;

    try {
      // Verificar se o navegador suporta notificações push
      const isMessagingSupported = await isSupported();
      if (!isMessagingSupported) {
        console.log('Este navegador não suporta notificações push');
        return false;
      }

      // Inicializar o serviço de mensagens
      this.messaging = getMessaging(firebaseApp);
      this.initialized = true;
      
      // Configurar o handler para mensagens em foreground
      onMessage(this.messaging, (payload) => {
        console.log('Mensagem recebida em foreground:', payload);
        if (this.onMessageCallback) {
          this.onMessageCallback(payload);
        }
      });

      return true;
    } catch (error) {
      console.error('Erro ao inicializar o serviço de notificações:', error);
      return false;
    }
  }

  /**
   * Solicita permissão para notificações push e registra o token
   * @returns {Promise<string|null>} O token FCM ou null em caso de erro
   */
  async requestPermissionAndGetToken() {
    if (!this.initialized && !(await this.init())) {
      return null;
    }

    try {
      // Verificar se já temos permissão
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('Permissão para notificações negada');
        return null;
      }

      // Obter o token FCM
      // A chave VAPID é uma chave pública que pode ser hardcoded, não é um segredo
      const token = await getToken(this.messaging, {
        vapidKey: "BKt5CgXcbpHGKr8FdWBpcGTN-lKiKgJKFZplOEYiZFb5bJqncKhx_ORgB5SKY14iL3WEjFXlDcptx7_fH2qXs4I"
      });

      console.log('Token FCM obtido:', token);
      return token;
    } catch (error) {
      console.error('Erro ao solicitar permissão ou obter token:', error);
      return null;
    }
  }

  /**
   * Registra um callback para ser chamado quando uma notificação for recebida em foreground
   * @param {Function} callback A função a ser chamada
   */
  onMessageReceived(callback) {
    this.onMessageCallback = callback;
  }

  /**
   * Verifica se o navegador suporta notificações
   * @returns {Promise<boolean>}
   */
  async isNotificationSupported() {
    return 'Notification' in window;
  }

  /**
   * Verifica o status atual da permissão de notificações
   * @returns {string} 'granted', 'denied' ou 'default'
   */
  getNotificationPermissionStatus() {
    if (!('Notification' in window)) {
      return 'unsupported';
    }
    return Notification.permission;
  }
}

// Exportar como singleton
export const notificationService = new NotificationService(); 